export default __webpack_public_path__ + "static/media/testimonials@2x.7e1a6015.png";